// extracted by mini-css-extract-plugin
export var wrapper = "post-module--wrapper--23nOn";
export var content = "post-module--content--2szKF";
export var titleStyle = "post-module--titleStyle--mQkjM";